import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { IUnternehmenResponse } from '@shared/model/company-http.model';
import { API_ROUTE_SEARCH_UNTERNEHMEN, getApiUrl } from '../../app.constants';
import { catchError, Observable } from 'rxjs';
import { UnternehmenSearchRequest } from '../../model/unternehmen-search-request.model';
import { IkpPopupService } from '@shared/service/popup/popup.service';

@Injectable({
  providedIn: 'root',
})
export class UnternehmenService extends ApiService {
  private readonly popupService = inject(IkpPopupService);

  searchUnternehmen(unternehmenSearchRequest: UnternehmenSearchRequest): Observable<IUnternehmenResponse> {
    return this.httpClient.post<IUnternehmenResponse>(getApiUrl(this.apiUrl, API_ROUTE_SEARCH_UNTERNEHMEN), unternehmenSearchRequest).pipe(
      catchError(error => {
        this.handleErrorCompanySearch();
        throw error;
      }),
    );
  }

  private handleErrorCompanySearch(): void {
    this.popupService.handleErrorPopup('search-companies-error', 'global.errors.companySection.title');
  }
}
